export const HEADER = {
  pt: {
    products: "Produtos",
    services: "Serviços",
    pricing: "Preçário",
    priceIndex: "Índice de Preços",
    company: "Empresa",
    contact: "Contacte-nos",
    signUp: "Registar",
    signIn: "Entrar",
    existing: "Utilizador existente?",
    recentNews: "Notícias recentes",
    product: {
      title: "Soluções para o dia-a-dia",
      valuations: {
        name: "Estudos de mercado",
        description:
          "Crie estudos de mercado para imóveis residenciais e comerciais em segundos",
      },
      metasearch: {
        name: "Prospeção",
        description:
          "Procure por qualquer imóvel e conheça todo o seu historial",
      },
      insights: {
        name: "Estatísticas de mercado",
        description:
          "Aceda a estatísticas e tendências únicas para qualquer região em tempo real",
      },
      website: {
        name: "Website Pro",
        description: "Fortaleça a sua presença online instantaneamente",
      },
      digitalValuer: {
        name: "Avaliador online",
        description:
          "Gere novas leads de vendedor e converta-as em angariações",
      },
    },
    solutions: {
      title: "Soluções de automação - Serviços",
      portfolio: {
        name: "Gestão de portfólio",
        description:
          "Analise e monitorize todos os seus portfólios imobiliários",
      },
      risk: {
        name: "Análise de risco",
        description: "Compare a performance dos seus ativos com o mercado",
      },
      opportunities: {
        name: "Encontre oportunidades",
        description: "Identifique novos investimentos anteriormente escondidos",
      },
      avms: {
        name: "Customização de AVMs",
        description: "Tecnologia de Inteligência Artificial de última geração",
      },
      observatory: {
        name: "Observatório de dados",
        description: "Ganhe uma intuição única sobre o mercado",
      },
    },
    resources: {
      about: {
        name: "Sobre",
        description: "Saiba mais sobre a COMPANY_NAME",
      },
      careers: {
        name: "Carreiras",
        description: "Descubra oportunidades de carreira na COMPANY_NAME",
      },
      cases: {
        name: "Casos de uso",
        description:
          "Aplicações práticas da nossa tecnologia no mercado imobiliário",
      },
      security: {
        name: "Segurança",
        description: "Entenda como cuidamos da sua privacidade.",
      },
    },
    recentPosts: {
      post1: "Índice de Preços Residencial 🔥",
    },
  },
  en: {
    products: "Products",
    services: "Services",
    pricing: "Pricing",
    priceIndex: "Price Index",
    company: "Company",
    contact: "Contact us",
    signUp: "Sign up",
    signIn: "Sign in",
    existing: "Existing customer?",
    recentNews: "Recent news",
    product: {
      title: "Everyday essentials",
      valuations: {
        name: "Property valuation",
        description:
          "Create residential and commercial property valuation reports in seconds",
      },
      metasearch: {
        name: "Metasearch",
        description:
          "Search for any property currently on the market and know its full history",
      },
      insights: {
        name: "Market insights",
        description:
          "Access unique real-time analytics and market trends for any region",
      },
      website: {
        name: "Website Pro",
        description: "Strengthen your online presence instantaneously",
      },
      digitalValuer: {
        name: "Digital valuer",
        description: "Generate seller leads and turn them into mandates.",
      },
    },
    solutions: {
      title: "Automation products - Taylored",
      portfolio: {
        name: "Portfolio management",
        description:
          "Analyse and value your real estate portfolios effortlessly",
      },
      risk: {
        name: "Risk analysis",
        description: "Benchmark against tailored market indicators",
      },
      opportunities: {
        name: "Find opportunities",
        description:
          "Actionable analysis to identify new opportunities within your portfolio",
      },
      avms: {
        name: "Valuation solutions",
        description: "State-of-the-art Automatic Valuation Model (AVM)",
      },
      observatory: {
        name: "Data observatory",
        description:
          "Gain a unique perspective into how the market is behaving",
      },
    },
    resources: {
      about: {
        name: "About",
        description: "Learn more about COMPANY_NAME",
      },
      careers: {
        name: "Careers",
        description: "Discover careers opportunities at COMPANY_NAME",
      },
      cases: {
        name: "Use cases",
        description:
          "Practical applications of our technology in the real estate industry",
      },
      security: {
        name: "Security",
        description: "Understand how we take your privacy seriously.",
      },
    },
    recentPosts: {
      post1: "Residential Price Index 🔥",
    },
  },
  es: {
    products: "Productos",
    services: "Servicios",
    pricing: "Precios",
    priceIndex: "Índice de Precios",
    company: "Empresa",
    contact: "Contáctenos",
    signUp: "Registrarse",
    signIn: "Log in",
    existing: "¿Cliente existente?",
    recentNews: "Noticias recientes",
    product: {
      title: "Soluciones para el día a día",
      valuations: {
        name: "Estudios de mercado",
        description: "Cree estudios de mercado en segundos",
      },
      metasearch: {
        name: "Buscador inmobiliario",
        description: "Conéctese con el mercado, ahorre tiempo",
      },
      insights: {
        name: "Estadísticas",
        description: "Conozca las tendencias en tiempo real",
      },
      website: {
        name: "Sitio web profesional",
        description: "Fortalece tu presencia online",
      },
      digitalValuer: {
        name: "Valorador digital",
        description: "Generar leads y convertirlas en mandatos",
      },
    },
    solutions: {
      title: "Automatización - Servicios",
      portfolio: {
        name: "Portafolio",
        description: "Analice miles de activos por cartera",
      },
      risk: {
        name: "Riesgo",
        description: "Benchmark contra indicadores de mercado personalizados",
      },
      opportunities: {
        name: "Encuentre oportunidades",
        description:
          "Análisis procesable para identificar nuevas oportunidades",
      },
      avms: {
        name: "AVMs hechos a la medida",
        description: "IA de última generación",
      },
      observatory: {
        name: "Observatorio",
        description: "Construir un observatorio de datos",
      },
    },
    resources: {
      about: {
        name: "Sobre nosotros",
        description:
          "Obtenga respuesta a todas sus preguntas de nuestros foros o contacto con el cliente",
      },
      careers: {
        name: "Carreras",
        description:
          "Aprenda a maximizar nuestra plataforma para aprovecharla al máximo",
      },
      cases: {
        name: "Casos de uso",
        description:
          "Vea reuniones y otros eventos que podemos estar planeando cerca de usted",
      },
      security: {
        name: "Seguridad",
        description: "Comprenda cómo cuidamos su privacidad",
      },
    },
    recentPosts: {
      post1: "Índice de Precios Residenciales 🔥",
    },
  },
};
